// extracted by mini-css-extract-plugin
export default {"similar_users_container":"SimilarUsers_similar_users_container__dBe6F"};